export interface IdentityHeaderProps {
  showBack?: boolean;
  backHref?: string;
  brandHref?: string;
}

export function IdentityHeader({
  showBack,
  backHref = "/",
  brandHref = "/login",
}: IdentityHeaderProps) {
  return (
    <>
      {showBack && backHref ? (
        <a className="sc-identity-back" href={backHref}>
          ← Back
        </a>
      ) : null}
      <a href={brandHref} className="sc-identity-brand" aria-label="SpeedyCore Identity">
        SpeedyCore Identity
      </a>
    </>
  );
}
